export default __webpack_public_path__ + "static/media/0x5ceebb0947d58fabde2fc026ffe4b33ccfe1ba8b.5480a980.webp";